import styled from "@emotion/styled";

export const GridRoot = styled.div({
    listStyle: "none",
    marginLeft: -60,
});

interface GridColProps {
    widthUnits: number;
    totalUnits: number;
    alignBottom?: boolean;
}

const middleScreen = `@media (max-width: 700px)`;

export const GridItem = styled.div<GridColProps>(
    {
        boxSizing: "border-box",
        display: "inline-block",
        marginRight: "-0.25em",
        minHeight: 1,
        paddingLeft: 60,
        verticalAlign: "top",

        [middleScreen]: {
            display: "block",
            marginLeft: 0,
            marginRight: 0,
            width: "auto",
        },
    },
    props => ({
        width: `${(Math.round((props.widthUnits / props.totalUnits) * 10000000) / 100000).toString()}%`,
    }),
    props => props.alignBottom && { verticalAlign: "bottom" }
);
